(() => {
  const root = document.querySelector('#root');
  if (!root || !document.querySelector('#df-offer-3')) return;
  document.querySelectorAll('[data-df-close]').forEach(b => b.addEventListener('click', () => { b.closest('dialog').close(); }));
  document.querySelectorAll('dialog').forEach(d => {
    d.addEventListener('click', e => { if (e.target === d) d.close(); });
    d.addEventListener('close', () => d.querySelector('video')?.pause());
  });
  root.addEventListener('click', e => {
    const label = e.target.closest('label[for^="bundle-"]');
    if (label) {
      e.preventDefault();
      const qty = label.htmlFor.split('-')[1];
      const clone = document.querySelector('#df-offer-' + qty).content.cloneNode(true);
      clone.querySelectorAll('input[type=radio]').forEach(i => { i.checked = i.value === qty; });
      stickyObserver?.unobserve(document.querySelector('#hero-purchase'));
      document.querySelector('#hero-purchase').replaceWith(clone);
      stickyObserver?.observe(document.querySelector('#hero-purchase'));
      document.querySelectorAll('#hero-purchase [data-df-buy] span').forEach(span => {
        if (/Comprar\s+Agora/i.test(span.textContent || '')) span.textContent = 'Adicionar ao Carrinho';
      });
      document.querySelectorAll('[data-df-sticky] p').forEach(p => p.textContent = ({1:'R$ 49,99',2:'R$ 89,99',3:'R$ 119,99'})[qty]);
      return;
    }
    const accordion = e.target.closest('[data-df-accordion]');
    if (accordion) {
      const panel = accordion.nextElementSibling;
      const opening = panel.hidden;
      root.querySelectorAll('[data-df-accordion]').forEach(b => { b.nextElementSibling.hidden = true; b.setAttribute('aria-expanded','false'); });
      panel.hidden = !opening;
      accordion.setAttribute('aria-expanded', String(opening));
      return;
    }
    if (e.target.closest('[data-df-show-seals]')) { document.querySelector('[data-df-seals]').hidden = false; return; }
    const seals = e.target.closest('[data-df-seals]');
    if (seals && (e.target.closest('button') || e.target === seals)) seals.hidden = true;
    const play = e.target.closest('button[aria-label^="Reproduzir vídeo"]');
    if (play) {
      videoIndex = Number(play.getAttribute('aria-label').match(/\d+/)[0])-1;
      videoModal.hidden=false; showVideo(videoIndex);
    }
  });
  const videoModal=document.querySelector('#df-video');
  const videoSources=[...new Set([...root.querySelectorAll('button[aria-label^="Reproduzir vídeo"] video')].map(v=>v.src))];
  let videoIndex=0;
  function showVideo(n){ videoIndex=(n+videoSources.length)%videoSources.length; const v=videoModal.querySelector('video'); v.src=videoSources[videoIndex];v.muted=false;v.play().catch(()=>{});videoModal.lastElementChild.textContent=`${videoIndex+1} / ${videoSources.length}`; }
  function closeVideo(){videoModal.hidden=true;videoModal.querySelector('video').pause();}
  videoModal.querySelector('[aria-label="Fechar"]').addEventListener('click',closeVideo);
  videoModal.querySelectorAll('[aria-label="Vídeo anterior"]').forEach(b=>b.addEventListener('click',()=>showVideo(videoIndex-1)));
  videoModal.querySelectorAll('[aria-label="Próximo vídeo"]').forEach(b=>b.addEventListener('click',()=>showVideo(videoIndex+1)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') {document.querySelector('[data-df-seals]')?.setAttribute('hidden','');closeVideo();} });
  const track = root.querySelector('[data-df-gallery-track]');
  const gallery = root.querySelector('[data-df-gallery]');
  let index = 0;
  const getGalleryCount = () => Math.max(1, track?.children.length || root.querySelectorAll('[data-df-thumb]').length || 1);
  function show(n) {
    const galleryCount = getGalleryCount();
    index = (n + galleryCount) % galleryCount;
    if (!track) return;
    track.style.transform = `translateX(-${index * 100}%)`;
    root.querySelectorAll('[data-df-thumb]').forEach(b => {
      const active = Number(b.dataset.dfThumb) === index;
      b.classList.toggle('opacity-50',!active); b.classList.toggle('opacity-100',active);
      ['ring-2','ring-orange-500','shadow-md'].forEach(c => b.classList.toggle(c,active));
    });
    root.querySelectorAll('[data-df-dot]').forEach(b => {
      const active = Number(b.dataset.dfDot) === index;
      b.className = 'transition-all rounded-full ' + (active ? 'bg-orange-500 w-6 h-1.5' : 'bg-gray-300 w-1.5 h-1.5');
      b.setAttribute('aria-label',`Imagem ${Number(b.dataset.dfDot)+1}`);
    });
  }
  root.querySelectorAll('[data-df-thumb]').forEach(b => b.addEventListener('click', () => show(Number(b.dataset.dfThumb))));
  root.querySelectorAll('[data-df-dot]').forEach(b => b.addEventListener('click', () => show(Number(b.dataset.dfDot))));
  root.querySelector('[aria-label="Imagem anterior"]')?.addEventListener('click', () => show(index-1));
  root.querySelector('[aria-label="Próxima imagem"]')?.addEventListener('click', () => show(index+1));
  let startX = 0;
  gallery?.addEventListener('touchstart',e => startX=e.changedTouches[0].clientX,{passive:true});
  gallery?.addEventListener('touchend',e => { const dx=e.changedTouches[0].clientX-startX; if(Math.abs(dx)>45) show(index+(dx<0?1:-1)); },{passive:true});
  show(0);
  root.querySelectorAll('button video').forEach(v => {v.muted=true; v.play().catch(()=>{});});
  const favorite=root.querySelector('button:has(.lucide-heart)');
  if(favorite){favorite.setAttribute('aria-label','Favoritar');favorite.addEventListener('click',()=>{const selected=favorite.getAttribute('aria-pressed')!=='true';favorite.setAttribute('aria-pressed',String(selected));favorite.querySelector('svg').setAttribute('fill',selected?'currentColor':'none');});}
  const share=root.querySelector('button:has(.lucide-share-2)');
  if(share){share.setAttribute('aria-label','Compartilhar');share.addEventListener('click',()=>{navigator.clipboard?.writeText(location.href);share.setAttribute('aria-label','Link copiado');});}
  const promo=root.querySelector('.bg-orange-500.text-white.w-full');
  if(promo){let alt=false;setInterval(()=>{alt=!alt;promo.querySelectorAll('[style*="flex-direction: column"]').forEach(el=>{el.style.transition='transform .35s';el.style.transform=alt?'translateY(-40px)':'translateY(0)';});},4000);}
  const sticky = root.querySelector('[data-df-sticky]');
  const stickyObserver = sticky ? new IntersectionObserver(entries => {sticky.hidden=entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;},{threshold:0}) : null;
  stickyObserver?.observe(root.querySelector('#hero-purchase'));
  const ingredientSection = [...root.querySelectorAll('section')].find(s => s.querySelector('h2')?.textContent?.replace(/\s+/g,' ').trim()==='Diferenciais e Ativos');
  ingredientSection?.querySelectorAll('button').forEach(b => {
    b.setAttribute('aria-label','Próximos ativos');
    const scroller=ingredientSection.querySelector('.overflow-x-auto');
    const previous=b.cloneNode(true);
    previous.setAttribute('aria-label','Ativos anteriores');
    previous.style.right='auto';previous.style.left=b.className.includes('right-1')?'4px':'-16px';
    previous.querySelector('svg').style.transform='rotate(180deg)';previous.hidden=true;b.parentElement.append(previous);
    b.addEventListener('click',()=>scroller.scrollBy({left:scroller.clientWidth*.8,behavior:'smooth'}));
    previous.addEventListener('click',()=>scroller.scrollBy({left:-scroller.clientWidth*.8,behavior:'smooth'}));
    scroller.addEventListener('scroll',()=>{previous.hidden=scroller.scrollLeft<10;b.hidden=scroller.scrollLeft+scroller.clientWidth>=scroller.scrollWidth-10;},{passive:true});
  });
  const ingredientScroller=ingredientSection?.querySelector('.overflow-x-auto');
  if(ingredientScroller){
    ingredientScroller.dataset.dfIngredientScroller = 'true';
    ingredientScroller.style.touchAction = 'pan-x';
    ingredientScroller.style.webkitOverflowScrolling = 'touch';
    let x=0,left=0;
    ingredientScroller.addEventListener('touchstart',e=>{x=e.touches[0].clientX;left=ingredientScroller.scrollLeft;},{passive:true});
    ingredientScroller.addEventListener('touchmove',e=>{ingredientScroller.scrollLeft=left+x-e.touches[0].clientX;},{passive:true});
  }
  root.dataset.dfControlsReady='true';
  let countdown=2*3600+44*60+37;
  setInterval(() => {
    countdown=Math.max(0,countdown-1);
    const timer=[...root.querySelectorAll('#hero-purchase span')].find(x=>/^\d{2}:\d{2}:\d{2}$/.test(x.textContent.replace(/\s/g,'')));
    if(timer){const text=[Math.floor(countdown/3600),Math.floor(countdown%3600/60),countdown%60].map(x=>String(x).padStart(2,'0')).join(':');const node=[...timer.childNodes].find(n=>n.nodeType===Node.TEXT_NODE);if(node)node.textContent=text;}
  },1000);
})();
